import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../Styles/TopDeals.css";
import { FaFacebookF, FaInstagram, FaYoutube, FaHeadphones } from "react-icons/fa";

const PaymentMethods = ({ user }) => (
  <div className="container py-5">
    <div className="elementor-container elementor-column-gap-default">
      <div className="elementor-column elementor-col-100 elementor-top-column">
        <div className="elementor-widget-wrap elementor-element-populated">
          <div className="elementor-widget elementor-widget-heading">
            <div className="elementor-widget-container">
              <h2 className="elementor-heading-title">Payment Methods</h2>
            </div>
          </div>
          <div className="elementor-widget elementor-widget-text-editor">
            <div className="elementor-widget-container">
              <p><strong>Payment Policy</strong></p>
              <p>We accept secure online payments through <strong>Razorpay</strong>, one of India's leading payment gateways.</p>
              <p>The following payment methods are accepted:</p>
              <p>
                Credit & Debit Cards (Visa, Mastercard, American Express)<br />
                Net Banking (all major Indian banks)<br />
                UPI (Google Pay, PhonePe, Paytm, and others)<br />
                Wallets<br />
                EMI options (select cards)
              </p>
              <p>We also accept Cash on Delivery (COD) orders with a limit of ₹5,000.</p>
              <p>After selecting checkout, you will be securely redirected to the Razorpay platform to complete your transaction.</p>
              <p>All refunds will be processed back to your original method of payment.</p>
              <br />
              <p><strong>Contact Us:</strong></p>
              <p>Mati Foods LLP, Mati Farms,<br />Gurgaon Faridabad Road,<br />Opp. Paras Trade Centre,<br />Gwalpahari, Gurgaon 122002</p>
              <p>Email us: <a href="mailto:support@matihaat.com">support@matihaat.com</a><br />Call us: +91 9654870373</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer style={{ backgroundColor: "#f9f9f9", color: "#2b2b2b", padding: "40px 0" }}>
      <Container>
        <Row className="text-center text-md-start">
          {/* Left Column */}
          <Col md={4} className="mb-4 mb-md-0">
            <img
              src="https://matifoods.in/wp-content/uploads/2022/04/Mati-Haat-Web-Logo-2.png"
              alt="Mati Haat"
              style={{ width: "130px", marginBottom: "20px" }}
            />
            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
              <FaHeadphones style={{ color: "#8BC34A", fontSize: "30px", marginRight: "10px" }} />
              <div>
                <p className="mb-0">Got Questions? Call us 24/7!</p>
                <strong>+91 9654870373</strong>
              </div>
            </div>
            <div className="mt-4 d-flex justify-content-center justify-content-md-start gap-3">
              <a href="https://www.facebook.com/profile.php?id=61550736893804" style={{ color: "#000" }} className=" fs-5" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              <a href="https://www.instagram.com/matihaat/" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
              <a href="https://www.youtube.com/@FarmingwithMatihaat" style={{ color: "#000" }} className="fs-5" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
            </div>
          </Col>

          {/* Middle Column - Quick Links */}
          <Col md={4} className="mb-4 mb-md-0">
            <h5 style={{ color: "#7BA127" }}>Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/about-us" style={{ color: "#000" }} className="text-decoration-none">About Us</a></li>
              <li><a href="/contact-us" style={{ color: "#000" }} className="text-decoration-none">Reach Us</a></li>
              <li><a href="/track-order" style={{ color: "#000" }} className="text-decoration-none">Track your Order</a></li>
            </ul>
          </Col>

          {/* Right Column - Customer Care */}
          <Col md={4}>
            <h5 style={{ color: "#7BA127" }}>Customer Care</h5>
            <ul className="list-unstyled">
              <li><a href="/privacy-policy" style={{ color: "#000" }} className="text-decoration-none">Privacy Policy</a></li>
              <li><a href="/shipping-policy" style={{ color: "#000" }} className="text-decoration-none">Shipping Policy</a></li>
              <li><a href="/refund-policy" style={{ color: "#000" }} className="text-decoration-none">Refund and Returns Policy</a></li>
              <li><a href="/payment-methods" style={{ color: "#000" }} className="text-decoration-none">Payment Methods</a></li>
              <li><a href="/terms-and-conditions" style={{ color: "#000" }} className="text-decoration-none">Terms and Conditions</a></li>
            </ul>
          </Col>
        </Row>
      </Container>
    </footer>
  </div>
);

export default PaymentMethods;
